
import { computed, defineComponent, ref } from "vue";
import { FormDialog, UploadImage } from "@/components/Common";

import { useDialogCommon, useDialogFormData } from "@/hooks";
import { initFormData, rules } from "./ExcelImport";

import { ElMessage } from "element-plus";
import { useStore } from "vuex";
import { Download } from "@element-plus/icons";
import { GetOrderAddressExcelExport } from "@/api-server/modules/defaultServer";

export default defineComponent({
  props: {
    visible: { type: Boolean, default: false },
    formData: {
      type: Object,
      default: () => ({ ...initFormData }),
    },
  },

  components: {
    FormDialog,
    UploadImage,
    Download,
  },

  emits: ["update:visible", "updateSuccess"],

  setup(props, context) {
    const store = useStore();
    const { visibleRef } = useDialogCommon(props, context);
    const { editFormData } = useDialogFormData(props, initFormData, {
      type: "resetWithPropsFormData",
      visiableRef: visibleRef,
    });

    async function handleDown() {
      window.open('https://fscdn.zto.com/fs8/M00/61/02/CgRfYWIpw16AI35gAAAoMAA1nwM63.xlsx?filename=%E4%B8%8B%E5%8D%95%E6%A8%A1%E6%9D%BF.xlsx');
    }

    async function saveFormHandle() {
      const {
        data: { data },
      } = await GetOrderAddressExcelExport.fetch({
        ...editFormData.value,
        filePath: (editFormData.value?.filePath as any)?.name
      });
      context.emit("updateSuccess", data);
      visibleRef.value = false;
    }

    return {
      visibleRef,
      handleDown,
      editFormData,
      rules,
      saveFormHandle,
    };
  },
});
